"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _layouts = require("../layouts");

var _utils = require("../../utils");

var _components = require("../../components");

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reactRouter = require("react-router");

var _subscriptions = require("../../redux/modules/subscriptions");

var _user = require("../../redux/modules/user");

var _payments = require("../../redux/modules/payments");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Upgrade = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params;
    var to = params.to;


    return _bluebird2.default.all([dispatch((0, _subscriptions.getSubscriptionPlans)()), dispatch((0, _user.load)()).then(function () {
      var from = getState().user.subscription.planId;


      return dispatch((0, _subscriptions.getUpgrade)(from, to));
    })]);
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    subscription: state.user.subscription,
    plans: state.subscriptions.plans,
    userEmail: state.user.email,
    upgrades: state.subscriptions.upgrades
  };
}, { getPrice: _payments.getPrice, buyUpgrade: _subscriptions.buyUpgrade }), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(Upgrade, _React$Component);

  function Upgrade(props) {
    (0, _classCallCheck3.default)(this, Upgrade);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Upgrade.__proto__ || (0, _getPrototypeOf2.default)(Upgrade)).call(this));

    _this.state = {
      from: props.subscription.planId
    };
    return _this;
  }

  (0, _createClass3.default)(Upgrade, [{
    key: "renderUpgradeBox",
    value: function renderUpgradeBox() {
      var upgrades = this.props.upgrades;


      var to = this.getToPlan();
      var from = this.getFromPlan();

      var name = "Subscription Upgrade";
      var description = "From " + from.type + " to " + to.type;
      var price = upgrades.prices.oneOffCharge;


      return _react2.default.createElement(_components.CheckoutSummaryBox, (0, _extends3.default)({ name: name, description: description }, price));
    }
  }, {
    key: "getToPlan",
    value: function getToPlan() {
      var _props = this.props,
          params = _props.params,
          plans = _props.plans;
      var to = params.to;


      return plans.find(function (p) {
        return p.type == to;
      });
    }
  }, {
    key: "getFromPlan",
    value: function getFromPlan() {
      var _props2 = this.props,
          params = _props2.params,
          plans = _props2.plans;
      var from = this.state.from;


      return plans.find(function (p) {
        return p.type == from;
      });
    }
  }, {
    key: "handlePayment",
    value: function handlePayment(props) {
      var _props3 = this.props,
          upgrades = _props3.upgrades,
          buyUpgrade = _props3.buyUpgrade;

      var to = this.getToPlan();
      var price = upgrades.prices.oneOffCharge;


      if (props.paymentMethodToken) {
        return buyUpgrade({
          planId: to.type,
          amount: price.price,
          paymentMethodToken: props.paymentMethodToken
        });
      }

      return _promise2.default.reject(new Error("`paymentMethodToken` is required to make a payment"));
    }
  }, {
    key: "renderFinalScreen",
    value: function renderFinalScreen(values) {
      var styles = require("./Upgrade.scss");
      var name = values.name,
          company = values.company,
          address = values.address,
          postalCode = values.postalCode,
          city = values.city,
          country = values.country,
          email = values.email,
          last4 = values.last4;
      var _props4 = this.props,
          userEmail = _props4.userEmail,
          upgrades = _props4.upgrades;
      var upgradedAssets = upgrades.acls;


      var to = this.getToPlan();
      var paymentLine = last4 ? "Credit card ending with " + last4 : "PayPal account: " + email;

      return _react2.default.createElement(
        "div",
        { className: styles.FinalScreen },
        _react2.default.createElement(
          "div",
          { className: styles.FinalScreen__header },
          _react2.default.createElement("span", { className: styles.FinalScreen__thankyouIcon }),
          _react2.default.createElement(
            "div",
            { className: styles.FinalScreen__thankyouNote },
            _react2.default.createElement(
              "h1",
              null,
              "You're all set!"
            ),
            _react2.default.createElement(
              "p",
              null,
              "Your subscription has been upgraded to ",
              to.name,
              "."
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: styles.FinalScreen__body },
          _react2.default.createElement(
            "div",
            { className: styles.FinalScreen__section },
            _react2.default.createElement(
              "h2",
              null,
              "Your billing details"
            ),
            name,
            _react2.default.createElement("br", null),
            company,
            company && _react2.default.createElement("br", null),
            address,
            address && _react2.default.createElement("br", null),
            city,
            city && _react2.default.createElement("br", null),
            postalCode,
            _react2.default.createElement("br", null),
            country,
            _react2.default.createElement("br", null),
            _react2.default.createElement("br", null),
            paymentLine
          ),
          _react2.default.createElement(
            "div",
            { className: styles.FinalScreen__section },
            "An invoice for this purchase has been emailed to you at: ",
            _react2.default.createElement("br", null),
            " ",
            _react2.default.createElement(
              "strong",
              null,
              userEmail
            ),
            _react2.default.createElement("br", null),
            _react2.default.createElement("br", null),
            "We can not wait to see the amazing art that you will create with your ",
            _react2.default.createElement(
              "strong",
              null,
              "upgraded"
            ),
            " Megascans subscription. :D"
          )
        ),
        _react2.default.createElement(
          "div",
          { className: styles.FinalScreen__footer },
          _react2.default.createElement(_components.Button, {
            link: true,
            to: "/profile",
            className: styles.FinalScreen__secondaryButton,
            label: "View Account"
          }),
          _react2.default.createElement(_components.Button, {
            link: true,
            to: "/types/everything",
            className: styles.FinalScreen__primaryButton,
            primary: true,
            label: "Start Browsing"
          })
        )
      );
    }
  }, {
    key: "handleVATCheck",
    value: function handleVATCheck(countryCode, vatNo) {
      this.setState({ countryCode: countryCode, vatNo: vatNo });
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require("./Upgrade.scss");
      var c = (0, _utils.mapAndJoinStyles)(styles);

      return _react2.default.createElement(
        _components.AppSideEffects,
        { darkBackground: true, documentTitle: "Checkout" },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.SiteHeaderGap, null),
          _react2.default.createElement("div", { className: styles.pageBackground }),
          _react2.default.createElement(
            "h1",
            { className: c("Subscribe__section-title") },
            "Checkout"
          ),
          _react2.default.createElement(
            _components.PageSection,
            null,
            _react2.default.createElement(
              "div",
              { className: c("PaymentFormContainer") },
              _react2.default.createElement(_components.PaymentWizard, {
                onVATCheck: this.handleVATCheck.bind(this),
                paymentCallback: this.handlePayment.bind(this),
                renderFinalScreen: this.renderFinalScreen.bind(this),
                allowCustomerEdit: false,
                transactionType: "switch-plan",
                paymentBehavior: "subscription"
              })
            ),
            _react2.default.createElement(
              "div",
              { className: c("CurrentSubscriptionBoxContainer") },
              this.renderUpgradeBox()
            )
          ),
          _react2.default.createElement(
            _components.PageSection,
            null,
            _react2.default.createElement(
              "div",
              { className: styles.PaymentFormFooter },
              _react2.default.createElement(
                "div",
                { className: styles.PaymentSupported },
                "We Accept"
              ),
              _react2.default.createElement("div", { className: styles.PaymentIcons }),
              _react2.default.createElement(
                "div",
                { className: styles.PaymentSeal },
                _react2.default.createElement(
                  "a",
                  {
                    href: "https://www.braintreegateway.com/merchants/2mgdr37qhn27xsmy/verified",
                    target: "_blank",
                    rel: "noreferrer"
                  },
                  _react2.default.createElement("img", {
                    src: "https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-dark.png",
                    width: "280px",
                    height: "44px"
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Upgrade;
}(_react2.default.Component)) || _class) || _class);
exports.default = Upgrade;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Upgrade/Upgrade.jsx
// module id = 2957
// module chunks = 0